import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from 'tss-react/mui';
import { TextField, MenuItem, Button } from "@mui/material";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import Board from "react-trello";
import { toast } from "../../services/toast";
import { i18n } from "../../translate/i18n";
import { useNavigate } from "react-router-dom";
import { parseISO, subMonths, isBefore } from "date-fns";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: theme.spacing(1),
  },
  filters: {
    display: "flex",
    gap: "10px",
    marginTop: '10px',
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  button: {
    background: "#10a110",
    border: "none",
    padding: "10px",
    color: "white",
    fontWeight: "bold",
    borderRadius: "5px",
    cursor: "pointer",
  },
}));

const statusOptions = [
  { value: "pending", label: "Pendiente" },
  { value: "open", label: "Abierto" },
  { value: "closed", label: "Cerrado" }
];

const Kanban = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const [tags, setTags] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [file, setFile] = useState({ lanes: [] });

  const [filters, setFilters] = useState({
    status: "open",
    date: "",
  });

  const [error, setError] = useState("");

  useEffect(() => {
    fetchTags();
  }, []);

  const fetchTags = async () => {
    try {
      const response = await api.get("/tags/kanban");
      setTags(response.data.lista || []);
      await fetchTickets();
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTickets = async () => {
    try {
      const queueIds = user.queues.map(queue => queue.UserQueue.queueId);

      const params = {
        queueIds: JSON.stringify(queueIds),
        status: filters.status,
        updatedAt: filters.date,
      };

      const { data } = await api.get("/ticket/kanban", { params });
      setTickets(data.tickets);
    } catch (err) {
      console.log(err);
      setTickets([]);
    }
  };

  const applyFilters = () => {
    setError("");
    fetchTickets();
  };

  const popularCards = () => {
    const filteredTickets = tickets.filter(ticket => ticket.tags.length === 0);

    const lanes = [
      {
        id: "lane0",
        title: i18n.t("Leads / Nuevos"),
        label: `${filteredTickets.length} registros`,
        cards: filteredTickets.map(ticket => ({
          id: ticket.id.toString(),
          label: "Ticket nº " + ticket.id.toString(),
          description: (
            <div>
              <p>{ticket.contact.number}<br />{ticket.lastMessage}</p>
              <button className={classes.button} onClick={() => handleCardClick(ticket.uuid)}>
                Ver Ticket
              </button>
            </div>
          ),
          title: ticket.contact.name,
          draggable: true,
          href: "/tickets/" + ticket.uuid,
        })),
      },
      ...tags.map(tag => {
        const tagTickets = tickets.filter(ticket =>
          ticket.tags.some(t => t.id === tag.id)
        );
        return {
          id: tag.id.toString(),
          title: tag.name,
          label: `${tagTickets.length} registros`,
          cards: tagTickets.map(ticket => ({
            id: ticket.id.toString(),
            label: "Ticket nº " + ticket.id.toString(),
            description: (
              <div>
                <p>{ticket.contact.number}<br />{ticket.lastMessage}</p>
                <button className={classes.button} onClick={() => handleCardClick(ticket.uuid)}>
                  Ver Ticket
                </button>
              </div>
            ),
            title: ticket.contact.name,
            draggable: true,
            href: "/tickets/" + ticket.uuid,
          })),
          style: { backgroundColor: tag.color, color: "white" },
        };
      }),
    ];

    setFile({ lanes });
  };

  useEffect(() => {
    popularCards();
  }, [tickets, tags]);

  const handleCardClick = (uuid) => {
    navigate("/tickets/" + uuid);
  };
  
  const handleCardMove = async (cardId, sourceLaneId, targetLaneId) => {
    try {
      const ticket = tickets.find(t => t.id.toString() === targetLaneId);
      if (ticket?.contact?.id) {
        await api.put(`/ticket-tags`, {
          tagId: sourceLaneId,
          ticketId: targetLaneId,
        });
        toast.success('¡Cambio de posición exitoso!');
      } else {
        toast.error('No se encontró el contacto asociado al ticket.');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error al cambiar la posición del ticket.');
    }
  };

  return (
    <div className={classes.root}>
      {}
      <div className={classes.filters}>
        <TextField
          select
          label="Estado"
          name="status"
          value={filters.status}
          onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          variant="outlined"
          size="small"
        >
          {statusOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          type="date"
          label="Fecha"
          name="date"
          value={filters.date}
          onChange={(e) => setFilters({ ...filters, date: e.target.value })}
          variant="outlined"
          size="small"
          error={!!error}
          helperText={error}
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />

        <Button variant="contained" color="primary" onClick={applyFilters}>
          Aplicar Filtros
        </Button>

      </div>
      {}
      <Board
        data={file}
        onCardMoveAcrossLanes={handleCardMove}
        style={{ backgroundColor: "rgba(252, 252, 252, 0.03)" }}
      />
    </div>
  );
};

export default Kanban;
